import { render, staticRenderFns } from "./FcEndElement.vue?vue&type=template&id=20603ccb&scoped=true&"
import script from "./FcEndElement.vue?vue&type=script&lang=js&"
export * from "./FcEndElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20603ccb",
  null
  
)

export default component.exports